import { FinanceSectionProps } from './types';

const FinanceSection = (props: FinanceSectionProps) => {
  const {
    action,
    children,
    title
  } = props;

  return (
    <section className="flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <h2 className="font-sans text-lg font-semibold leading-6 text-foreground">{title}</h2>
        {action}
      </div>
      {children}
    </section>
  );
};

export default FinanceSection;